var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRbacAuth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 588,
    height: 385,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h93.314v117.662H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M0 0h22.664v17.803H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#C5D4E3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.864 383.313s-68.745-66.607-25.01-144.97c43.735-78.365 102.475-38.956 99.632-130.165-2.843-91.209 135.09-99.045 178.995-72.598 43.904 26.447 43.642 58.299 134.277 47.76 90.637-10.538 107.953 77.313 84.373 122.087-33.457 63.526 92.855 53.048 13.265 177.886H46.864",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.463 384.662s-74.422-89.998-31.823-168.36c42.598-78.365 99.812-38.956 97.043-130.165-2.77-91.209 131.58-99.045 174.343-72.598 42.763 26.447 42.508 58.299 130.788 47.76 88.282-10.539 105.148 77.313 82.18 122.086-32.588 63.527 136.124 67.989 35.189 201.277H54.463z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.321 383.975H.678c-.373 0-.678-.287-.678-.635v-.243c0-.348.305-.635.678-.635H587.32c.373 0 .679.287.679.635v.243c0 .348-.306.635-.679.635"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.147 250.882c-9.929-3.983-21.208.821-25.197 10.734-3.989 9.91.825 21.175 10.751 25.158 9.929 3.98 21.208-.825 25.197-10.737 3.989-9.91-.826-21.175-10.751-25.155zm18.67-17.909a44.079 44.079 0 0 1 8.398 8.211l10.72-1.953 7.078 16.555-8.83 6.376c.558 3.844.615 7.79.128 11.735l8.96 6.185-6.723 16.702-10.751-1.726a44.089 44.089 0 0 1-8.227 8.385l1.957 10.703-16.583 7.066-6.386-8.816a44.295 44.295 0 0 1-11.754.128l-6.196 8.947-16.73-6.71 1.73-10.74a44.15 44.15 0 0 1-8.398-8.211l-10.721 1.954-7.075-16.556 8.83-6.376a44.083 44.083 0 0 1-.128-11.735l-8.961-6.184 6.721-16.703 10.754 1.724a44.075 44.075 0 0 1 8.227-8.382L94.9 222.846l16.582-7.064 6.387 8.816a44.293 44.293 0 0 1 11.753-.128l6.194-8.949 16.73 6.713-1.73 10.739z",
    fill: "#FFF",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.24 128.51c-3.954-1.588-8.451.328-10.04 4.277-1.59 3.95.33 8.438 4.285 10.025 3.956 1.587 8.45-.329 10.04-4.278 1.59-3.95-.329-8.438-4.285-10.025zm7.438-7.15a17.643 17.643 0 0 1 3.35 3.278l4.279-.78 2.824 6.607-3.523 2.545c.222 1.534.245 3.11.05 4.684l3.578 2.468-2.683 6.666-4.293-.688a17.558 17.558 0 0 1-3.283 3.346l.781 4.273-6.618 2.819-2.548-3.519a17.636 17.636 0 0 1-4.691.051l-2.472 3.571-6.678-2.678.69-4.286a17.531 17.531 0 0 1-3.35-3.278l-4.28.78-2.824-6.607 3.524-2.545a17.595 17.595 0 0 1-.05-4.684l-3.577-2.468 2.682-6.666 4.293.688a17.557 17.557 0 0 1 3.283-3.346l-.781-4.272 6.618-2.82 2.548 3.519a17.676 17.676 0 0 1 4.691-.051l2.472-3.571 6.677 2.678-.69 4.286zM442.524 281.241c-8.54-3.427-18.252.71-21.683 9.239-3.433 8.531.71 18.223 9.253 21.65 8.545 3.428 18.252-.709 21.685-9.238 3.433-8.53-.71-18.223-9.255-21.65zm16.069-15.479a38.127 38.127 0 0 1 7.24 7.083l9.247-1.686 6.102 14.28-7.614 5.5c.482 3.315.53 6.718.111 10.121l7.73 5.334-5.798 14.407-9.277-1.487a37.943 37.943 0 0 1-7.094 7.23l1.688 9.234-14.302 6.092-5.508-7.604c-3.32.483-6.727.53-10.137.11l-5.343 7.717-14.43-5.788 1.49-9.263a37.886 37.886 0 0 1-7.24-7.082l-9.249 1.685-6.102-14.28 7.616-5.499a38.023 38.023 0 0 1-.11-10.122l-7.729-5.334 5.797-14.406 9.277 1.487a37.942 37.942 0 0 1 7.094-7.23l-1.688-9.232 14.301-6.095 5.509 7.604a38.2 38.2 0 0 1 10.137-.11l5.342-7.717 14.429 5.788-1.49 9.263z",
    fill: "#FFF",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(136.87 164.284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.266 188.564H9.383A9.383 9.383 0 0 1 0 179.181V9.384C0 4.2 4.2 0 9.383 0h273.883c5.183 0 9.383 4.2 9.383 9.384V179.18c0 5.183-4.2 9.383-9.383 9.383",
    fill: "#4E596C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.48 162.782H17.892V19.525c0-4.89 3.712-8.854 8.29-8.854H268.19c4.579 0 8.29 3.964 8.29 8.854v143.257",
    fill: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 162.782v16.417c0 5.181 4.2 9.38 9.383 9.38h108.335v11.178a16.439 16.439 0 0 1-9.212 14.765l-10.605 5.194h95.446l-11.984-5.869a13.984 13.984 0 0 1-7.834-12.557v-12.71h109.737c5.183 0 9.383-4.2 9.383-9.381v-16.417H0",
    fill: "#4E596C"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313131",
    d: "M117.696 199.766v-11.202h55.8l-55.8 11.202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.175 26.814a1.908 1.908 0 1 1-3.817 0 1.908 1.908 0 0 1 3.817 0M50.962 26.814a1.909 1.909 0 1 1-3.818-.001 1.909 1.909 0 0 1 3.818 0M58.75 26.814a1.908 1.908 0 1 1-3.817 0 1.908 1.908 0 0 1 3.816 0M260.906 35.166c0 .12-50.918.217-113.714.217-62.818 0-113.726-.098-113.726-.217 0-.121 50.908-.218 113.726-.218 62.796 0 113.714.097 113.714.218",
    fill: "#334F55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5D4E3",
    d: "M52.114 104.797h49.744v-3.329H52.114zM116.366 58.58h49.745v-3.329h-49.745z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.097 67.648c0 .12-27.701.218-61.863.218-34.174 0-61.868-.098-61.868-.218s27.694-.217 61.868-.217c34.162 0 61.863.098 61.863.217M240.097 74.918c0 .12-27.701.217-61.863.217-34.174 0-61.868-.098-61.868-.217 0-.12 27.694-.218 61.868-.218 34.162 0 61.863.097 61.863.218M240.097 82.187c0 .119-27.701.217-61.863.217-34.174 0-61.868-.098-61.868-.217 0-.12 27.694-.218 61.868-.218 34.162 0 61.863.097 61.863.218M240.097 89.455c0 .12-27.701.218-61.863.218-34.174 0-61.868-.098-61.868-.218s27.694-.218 61.868-.218c34.162 0 61.863.098 61.863.218M240.097 96.724c0 .12-27.701.218-61.863.218-34.174 0-61.868-.097-61.868-.218 0-.12 27.694-.218 61.868-.218 34.162 0 61.863.098 61.863.218M164.664 103.993c0 .12-10.812.218-24.148.218-13.34 0-24.15-.098-24.15-.218s10.81-.218 24.15-.218c13.336 0 24.148.099 24.148.218M239.191 118.1c0 .12-18.206.218-40.66.218-22.461 0-40.665-.098-40.665-.217 0-.12 18.204-.218 40.664-.218 22.455 0 40.661.098 40.661.218M239.191 125.817c0 .12-18.206.217-40.66.217-22.461 0-40.665-.096-40.665-.217 0-.12 18.204-.218 40.664-.218 22.455 0 40.661.097 40.661.218M239.191 133.533c0 .12-18.206.217-40.66.217-22.461 0-40.665-.097-40.665-.217s18.204-.217 40.664-.217c22.455 0 40.661.097 40.661.217M239.191 141.25c0 .119-18.206.216-40.66.216-22.461 0-40.665-.097-40.665-.216 0-.122 18.204-.218 40.664-.218 22.455 0 40.661.096 40.661.218M101.984 117.362c0 .12-10.853.218-24.238.218-13.39 0-24.24-.098-24.24-.218s10.85-.218 24.24-.218c13.385 0 24.238.098 24.238.218M101.984 123.422c0 .12-10.853.218-24.238.218-13.39 0-24.24-.098-24.24-.218s10.85-.217 24.24-.217c13.385 0 24.238.097 24.238.217M101.984 129.482c0 .12-10.853.217-24.238.217-13.39 0-24.24-.097-24.24-.217s10.85-.218 24.24-.218c13.385 0 24.238.098 24.238.218M101.984 135.542c0 .12-10.853.217-24.238.217-13.39 0-24.24-.097-24.24-.217s10.85-.217 24.24-.217c13.385 0 24.238.096 24.238.217M101.984 141.601c0 .12-10.853.217-24.238.217-13.39 0-24.24-.097-24.24-.217s10.85-.217 24.24-.217c13.385 0 24.238.097 24.238.217",
    fill: "#858795"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F1F1",
    d: "M52.114 92.64h49.87V44.374h-49.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5D4E3",
    d: "m55.98 89.901 13.797-24.837L81.06 80.94l6.856-8.43 10.2 17.392H55.982M85.866 58.842a3.589 3.589 0 1 1-7.177 0 3.59 3.59 0 1 1 7.178 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F1F1",
    d: "M116.336 148.578h35.294v-34.159h-35.294z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5D4E3",
    d: "m119.072 145.654 9.763-17.577 7.986 11.234 4.853-5.965 7.22 12.308h-29.822M140.223 124.657a2.54 2.54 0 1 1-5.08.002 2.54 2.54 0 0 1 5.08-.002"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.656 20.016h38.887c.974 0 1.763.79 1.763 1.763v8.047H17.893v-8.047c0-.973.79-1.763 1.763-1.763z",
    fill: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#979797",
    strokeWidth: 0.881,
    fill: "#FFFFFE",
    cx: 56.297,
    cy: 24.888,
    rx: 1.779,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#979797",
    strokeWidth: 0.881,
    fill: "#FFFFFE",
    cx: 50.133,
    cy: 24.888,
    rx: 1.779,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#979797",
    strokeWidth: 0.881,
    fill: "#FFACAC",
    cx: 43.97,
    cy: 24.888,
    rx: 1.779,
    ry: 1.78
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M353.88 169.687c0 34.813-28.22 63.033-63.032 63.033-34.811 0-63.032-28.22-63.032-63.033 0-34.812 28.22-63.033 63.032-63.033s63.033 28.22 63.033 63.033",
    stroke: "#FFF",
    strokeWidth: 8.08,
    fill: "#E25D6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.916 165.781 6.886 26.662 6.454-26.64c21.906 3.143 38.89 21.36 39.914 43.7-11.456 11.807-27.493 19.145-45.244 19.145-19.147 0-36.3-8.537-47.86-22.012 2.282-21.069 18.814-37.908 39.85-40.855zm17.285-49.784c6.551 3.758 10.604 10.669 10.665 18.161v9.741c.002 6.641-3.57 12.78-9.371 16.1a24.183 24.183 0 0 1-23.975 0c-5.742-3.287-9.302-9.336-9.369-15.901v-9.769c0-7.56 4.064-14.547 10.665-18.332a21.52 21.52 0 0 1 21.385 0z",
    fill: "#EFAEBA"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(313.36 182.294)"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#36C0CE",
    strokeWidth: 2.327,
    fill: "#F4F5F7",
    x: 1.163,
    y: 1.163,
    width: 48.099,
    height: 48.1,
    rx: 24.05
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.88 20.64)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.931 0h18.802a1.93 1.93 0 0 1 1.931 1.929v13.97a1.93 1.93 0 0 1-1.93 1.93H1.93A1.93 1.93 0 0 1 0 15.899V1.93A1.93 1.93 0 0 1 1.931 0",
    fill: "#BBC0C4",
    mask: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E98799",
    mask: "url(#c)",
    d: "M0 3.45h22.664v-.62H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.664 4.767H1.317C.59 4.767 0 4.177 0 3.451h22.664v1.316",
    fill: "#9EA6AE",
    mask: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.664 2.83v-.901A1.93 1.93 0 0 0 20.734 0H1.93A1.93 1.93 0 0 0 0 1.929v.9h22.664",
    fill: "#E25D6F",
    mask: "url(#c)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.37 19.724H30.91V16.77a5.672 5.672 0 0 0-5.668-5.664 5.672 5.672 0 0 0-5.667 5.664v2.955h-3.461V16.77c0-5.031 4.095-9.124 9.128-9.124 5.034 0 9.13 4.093 9.13 9.124v2.955",
    fill: "#E25D6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.403 31.16a2.362 2.362 0 0 0 1.156-2.033 2.355 2.355 0 0 0-2.346-2.362 2.355 2.355 0 0 0-2.347 2.362c0 .867.466 1.623 1.157 2.034l-.726 3.48a.92.92 0 0 0 .897 1.112h2.038a.92.92 0 0 0 .897-1.111l-.726-3.481",
    fill: "#FFFFFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRbacAuth);
export default __webpack_public_path__ + "static/media/rbac_auth.e13302f7148d1ab7ef745aeb270a9752.svg";
export { ForwardRef as ReactComponent };